module.exports = __webpack_public_path__ + "static/media/logo_dark.c8ae707c.svg";